module.exports = function (name) { // eslint-disable-line
  return eval('require.main.require(name)');
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex/src/unsafeRequire.js
// module id = 572
// module chunks = 40